import { render, staticRenderFns } from "./UnterrichtDashboard.vue?vue&type=template&id=b55da524&scoped=true"
import script from "./UnterrichtDashboard.vue?vue&type=script&lang=ts"
export * from "./UnterrichtDashboard.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtDashboard.vue?vue&type=style&index=0&id=b55da524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55da524",
  null
  
)

export default component.exports